/* eslint-disable camelcase */
const ribbon = {
  props: {
    dynamicClass: ".c-ribbon.dynamicLoading",
    classNameClose: "c-ribbon__close-btn",
    classNameShow: "mod--show",
    nameAttrIndex: "data-index",
    animation: "animation-banner__frame-JS",
    animationTime: 10000,
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-ribbon.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document;

    this.initNodes(baseFind);
    this.transition(baseFind);
  },

  initNodes: function (baseFind) {
    bcl.u.forEach(baseFind.getElementsByClassName("ribbon"), ($element) => {
      this.searchNodesForClose($element, this.clickClose.bind(this));

      if (bcl.editMode || this.isValid($element)) {
        bcl.u.addClass($element, this.props.classNameShow);
      }
    });

    bcl.u.forEach(baseFind.querySelectorAll("main.root > .aem-Grid .parsys .ribbon"), ($element) => {
      this.searchNodesForClose($element, this.clickCloseDeleteMarginHeader.bind(this));

      const index = bcl.s.sticky.add(
        {
          $node: $element,
          callbackValid: this.isValid.bind(this),
          inHeader: true,
        },
        false,
      );

      this.appendRibbonToHeader($element);

      $element.setAttribute(this.props.nameAttrIndex, index);
    });
  },

  isValid: function ($node) {
    const $element = $node.firstElementChild,
      dateString = $element != null ? localStorage.getItem(this.getNameAttr($element)) : null;

    if (dateString) {
      const now = new Date(),
        old = new Date(dateString),
        diffDays = parseInt((now - old) / (1000 * 60 * 60 * 24));

      return diffDays >= this.getExpirationDaysAttr($element);
    }

    return true;
  },

  searchNodesForClose: function ($element, callback) {
    const $close = $element.getElementsByClassName(this.props.classNameClose);

    if ($close && $close[0]) {
      $close[0].addEventListener("click", callback);
      $close[0].addEventListener("keydown", (e) => {
        if (e.keyCode == 13 || e.keyCode == 32) {
          e.preventDefault();
          $close[0].click();
        }
      });
    }
  },

  clickClose: function (e) {
    const $ribbon = e.currentTarget.parentNode.parentNode;

    if ($ribbon) {
      bcl.u.removeClass($ribbon, this.props.classNameShow);
      localStorage.setItem(this.getNameAttr(e.currentTarget.parentNode), new Date());
    }
  },

  clickCloseDeleteMarginHeader: function (e) {
    const $ribbon = e.currentTarget.parentNode.parentNode;

    if ($ribbon) {
      bcl.s.sticky.remove($ribbon.getAttribute(ribbon.props.nameAttrIndex));
    }
  },

  getNameAttr: function ($element) {
    return "barcelo_" + $element.getAttribute("data-id");
  },

  getExpirationDaysAttr: function ($element) {
    return $element.getAttribute("data-expiration") || 30;
  },

  appendRibbonToHeader: function ($ribbon) {
    const $ribbon_copy = $ribbon.cloneNode(true),
      header = document.querySelector("header"),
      firstWebFragment = header && header.firstElementChild ? header.firstElementChild : null;

    bcl.c.ribbon.searchNodesForClose($ribbon_copy, bcl.c.ribbon.clickClose.bind(this));
    firstWebFragment && header.insertBefore($ribbon_copy, firstWebFragment);
    const ribbonParent = $ribbon.parentNode;
    ribbonParent.removeChild($ribbon);
  },

  transition: function (baseFind) {
    bcl.u.forEach(baseFind.getElementsByClassName("ribbon"), ($element) => {
      this.ribbonDynamic($element);
    });
  },

  ribbonDynamic: function ($element, slideIndex) {
    if (!slideIndex) {
      slideIndex = 0;
    }
    const $dynamicRibbons = $element.getElementsByClassName(this.props.animation);
    if ($dynamicRibbons.length > 0) {
      const aside = $element.querySelector(".c-ribbon");
      const time = aside && aside.dataset.transitionseconds ? aside.dataset.transitionseconds * 1000 : bcl.c.ribbon.props.animationTime;

      for (let i = 0; i < $dynamicRibbons.length; i++) {
        $dynamicRibbons[i].style.display = "none";
      }
      slideIndex++;
      if (slideIndex > $dynamicRibbons.length) {
        slideIndex = 1;
      }
      $dynamicRibbons[slideIndex - 1].style.display = "block";
      setTimeout(() => {
        this.ribbonDynamic($element, slideIndex);
      }, time);
    }
  },
};

export default ribbon;
